import { DEMO_IDS, DEMO_SLUG } from "@/lib/demoWorkspace";
import { getLiveChapterRoute, getLiveChapterSteps, type LiveTourContext } from "@/lib/liveProductTour";
import { enterDemoWorkspace } from "@/lib/demoSession";
import { useProductTourStore } from "@/stores/productTour";

export function demoTourContext(): LiveTourContext {
  return { festivalId: DEMO_IDS.festival, riderId: DEMO_IDS.rider, orgId: DEMO_IDS.organization, slotId: DEMO_IDS.slot, publicSlug: DEMO_SLUG, userId: DEMO_IDS.adminUser, campaignId: DEMO_IDS.campaign, hasArtistProfile: true, isMobile: window.innerWidth < 768 };
}

export function startLiveChapter(chapterId: string, ownerId: string, resume = false): string {
  const context = demoTourContext();
  const route = getLiveChapterRoute(chapterId, context);
  if (!route) throw new Error("This feature is not available in the guided workspace.");
  const progress = useProductTourStore.getState();
  const step = resume && progress.state.current_chapter === chapterId ? progress.state.current_step : 0;
  enterDemoWorkspace(ownerId);
  progress.update({ status: "in_progress", current_chapter: chapterId, current_step: step, chapter_id: chapterId, chapter_status: "seen" });
  return getLiveChapterSteps(chapterId, context)[step]?.route ?? route;
}
